module.exports = __webpack_public_path__ + "static/pod-intro-img-3-f48fac6dfd01a8fc6c0cbf048675b394.png";